import React from 'react';
import PropTypes from 'prop-types';

export default function ProfileIcon(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" className={props.className}>
      <path fill="#a4b0bf" fillRule="nonzero" d="M20.905 22.067V20.06c.417-.224 1.61-1.763 1.735-2.965.328-.027.844-.353.996-1.642.081-.692-.243-1.08-.44-1.203 0 0 .49-1.007.49-2.223 0-2.439-.884-4.52-2.781-4.52 0 0-.66-1.506-2.781-1.506-3.932 0-5.562 2.733-5.562 6.026 0 1.108.49 2.223.49 2.223-.197.123-.522.512-.44 1.203.152 1.289.667 1.615.996 1.642.125 1.202 1.318 2.74 1.735 2.965v2.008C14.416 25.08 7 23.072 7 30.101h22.248c0-7.03-7.416-5.02-8.343-8.034z"/>
    </svg>

  );
}

ProfileIcon.propTypes = {
  className: PropTypes.string,
};

ProfileIcon.defaultProps = {
  className: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/icons/ProfileIcon.jsx